module.exports = __webpack_public_path__ + "img/exercise_test-1.0411a0cf.png";